import { cn } from '@/utils/cn';
import { TYPE } from '@/lib/typography';
import { fileCategoryChipClass } from '@/lib/patientFileCategories';

export function FileCategoryChip({
  name,
  colorToken,
  className,
}: {
  name: string;
  colorToken: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        TYPE.meta,
        'inline-flex h-6 max-w-full items-center truncate rounded-full px-s2',
        fileCategoryChipClass(colorToken),
        className,
      )}
    >
      {name}
    </span>
  );
}
